import PropTypes from 'prop-types';
import React from 'react';
import { HorizontalSeparator, VerticalSeparator } from '../separator';
import MembersFilter from './member-filter';
import { MembersSortFieldMobile } from '../member-sort-field';
import withCardBackgroundColor from '../../hoc/with-card-background-color';
import styles from './member-header-mobile.scss';

const MemberHeaderMobile = ({ sort, onSortChange, filter, onFilterChange, membersCount, cardBackgroundColor }) =>
  <div className="default-forum-card-background-color" style={{ backgroundColor: cardBackgroundColor }}>
    <div className={styles.content}>
      <MembersSortFieldMobile className={styles.sort} value={sort} onChange={onSortChange}/>
      <VerticalSeparator className={styles.vertical}/>
      <MembersFilter className={styles.filter} value={filter} onChange={onFilterChange} count={membersCount}/>
    </div>
    <HorizontalSeparator/>
  </div>;

MemberHeaderMobile.propTypes = {
  sort: PropTypes.string.isRequired,
  onSortChange: PropTypes.func.isRequired,
  filter: PropTypes.string,
  onFilterChange: PropTypes.func.isRequired,
  membersCount: PropTypes.number,
  cardBackgroundColor: PropTypes.string,
};

export default withCardBackgroundColor(MemberHeaderMobile);



// WEBPACK FOOTER //
// ./app/components/member-header/member-header-mobile.js